module.exports = __webpack_public_path__ + "img/img_console.0b456b9a.jpg";